/**
 * Vilax Breadcrumbs — returns null.
 *
 * The Vilax exhibition site has flat content (language root + one page).
 * Breadcrumbs serve no navigation purpose and consume vertical space
 * that prevents the hero image from bleeding to the top.
 *
 * Shadows @kitconcept/volto-light-theme Breadcrumbs.
 * See header_overlay_breadcrumbs_spec.md §6: Landing variant hides breadcrumbs.
 *
 * DR-2026-055.
 */
const Breadcrumbs = () => null;

export default Breadcrumbs;
